import { onMounted, watch } from '@nuxtjs/composition-api'
import useUser from '../../composables/useUser'
import useCSR from './useCSR'

export default function useCSRLauncher(context) {
  // liveChat
  // const { initCSRWidget } = useCSR()
  //
  // onMounted(() => {
  //   initCSRWidget()
  // })

  // zendesk
  const { initCSRWidget, loginCSRWidget, logoutCSRWidget } = useCSR(context)

  const { user } = useUser(context)

  watch(user, (newVal, oldVal) => {
    if (newVal !== null && oldVal === null) {
      loginCSRWidget()
    }
    if (newVal === null && oldVal !== null) {
      logoutCSRWidget()
    }
  })

  onMounted(() => {
    initCSRWidget()

    if (user.value) {
      loginCSRWidget()
    }
  })
}
